import axios from './rest-axios';


const getGrowup = (yuyue_id, user_id) => axios.get(`/manage/growup/${yuyue_id}/${user_id}`);


export {
    getGrowup,
}
